<div class="card height-equal">
  <div class="card-body pt-4">
    <span class="help-icon fas fa-info-circle"
        [ngbTooltip]="tooltip.text | translate"
        [placement]="tooltip.placement"
        container="body"></span>
    <div class="row recent-wrapper">
      <div class="col-md-12">
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [legend]="chartOptions.legend"
          [title]="chartOptions.title"
          [labels]="chartOptions.labels">
        </apx-chart>
      </div>
    </div>
  </div>
</div>
